module.exports = __webpack_public_path__ + "img/pvi@2x.7a18441c.png";